<template>
  <div id="itemlist" class="location-selector">
    <div class="container-fluid p-0">
      <div class="row g-3">
        <!-- City Selection -->
        <div class="col-12 col-md-4">
          <div class="location-field">
            <label class="form-label"><span v-if="need" style="color: red;font-size: large;">*</span>縣市</label>
            <select
              v-model="twcity"
              @change="oncity()"
              class="form-select"
              aria-label="選擇縣市"
            >
              <option v-for="list in mytw" :value="list.city" :key="list.id">
                {{ list.city }}
              </option>
            </select>
          </div>
        </div>
        
        <!-- Village Selection -->
        <div class="col-12 col-md-4">
          <div class="location-field">
            <label class="form-label"><span v-if="need" style="color: red;font-size: large;">*</span>鄉鎮</label>
            <select
              v-model="twvillage"
              @change="onvillage()"
              class="form-select"
              aria-label="選擇鄉鎮"
            >
              <option
                v-for="list in twvillages"
                :value="list.village"
                :key="list.village"
              >
                {{ list.village }}
              </option>
            </select>
          </div>
        </div>
        
        <!-- Town Selection -->
        <div class="col-12 col-md-4">
          <div class="location-field">
            <label class="form-label"><span v-if="need" style="color: red;font-size: large;">*</span>村里</label>
            <select
              v-model="twtown"
              @change="ontwtown()"
              class="form-select"
              aria-label="選擇村里"
            >
              <option v-for="list in twtowns" :value="list.town" :key="list.town">
                {{ list.town }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import * as moment from "moment/moment";
import TWdata from "../assets/json/twdata.json";
import TW from "../assets/json/tw.json";
export default {
  name: 'Addresslist',
  props: {
    msg: String,
    item: Array,
    winsize: Object,
    need: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      myJson: TWdata,
      mytw: TW,
      address:'',
      twcity: "",
      twtown: "",
      twvillage: "",
      twvillages: [],
      twtowns: [],      
      window: {
            width: 0,
            height: 0
        }   
    }
  }, 
  computed: {
    ...mapState("account", ["status", "user"]),
  },  
  methods: {
    fdateformat(val){
        return moment(val.sdate).format("YYYY-MM-DD HH:mm") +'~'+ moment(val.edate).format("MM-DD HH:mm") ; 
    },
    catImg(imgs) {
            return require(`../assets/img/${imgs}`);
    }, 
    getxt(val){
        return val.substring(1, 32)
    },  
    groupBy(array, groups, valueKey) {
      var map = new Map();
      groups = [].concat(groups);
      return array.reduce((r, o) => {
        groups.reduce((m, k, i, { length }) => {
          var child;
          if (m.has(o[k])) return m.get(o[k]);
          if (i + 1 === length) {
            child = Object.assign(...groups.map(k => ({ [k]: o[k] })), {
              [valueKey]: 0
            });
            r.push(child);
          } else {
            child = new Map();
          }
          m.set(o[k], child);
          return child;
        }, map)[valueKey] += +o[valueKey];
        return r;
      }, []);
    },

    getaddress(){
      let city = this.twcity==undefined ? '':this.twcity
      let village = this.twvillage==undefined ? '':this.twvillage
      let town = this.twtown==undefined ? '':this.twtown
      this.address = city +''+ village +''+ town
      this.$emit("toaddress",this.address,city,village,town);
    },
    oncity() {
      this.twvillages = this.groupBy(
        this.myJson.filter(el => {
          return el.city === this.twcity;
        }),
        "village"
      );    
      this.twvillage='' 
      this.twtown=''
      this.twtowns = [];
      this.getaddress()
      //groupBy(data, 'Phase', 'Value')
    },

    onvillage() {
      this.twtowns = this.groupBy(
        this.myJson.filter(el => {
          return el.village === this.twvillage;
        }),
        "town"
      );
      this.twtown=''
      this.getaddress()
    },
    ontwtown(){
      this.getaddress()
    },     
  },   
  created() {
  }, 
  
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.location-selector {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}

.location-field {
  display: flex;
  flex-direction: column;
}

.form-label {
  font-weight: 500;
  margin-bottom: 0.5rem;
  color: #495057;
}

.form-select {
  height: calc(2.5rem + 2px);
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border-radius: 0.375rem;
  border: 1px solid #ced4da;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.form-select:focus {
  border-color: #86b7fe;
  box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
}

@media (max-width: 767.98px) {
  .location-field {
    margin-bottom: 0.5rem;
  }
  
  .form-select {
    width: 100%;
  }
}

/* Custom dropdown arrow styling */
.form-select {
  background-position: right 0.75rem center;
  background-size: 16px 12px;
}

</style>
